var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionFormatting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 9.86784",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0.524111V0H13.7464V0.524111H14.6111V9.34373H13.7464V9.86784H16V9.34373H15.1352V0.524111H16Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.0972388 7.73465L2.73487 1.77824C2.91876 1.36751 3.25376 1.11879 3.70792 1.11879H3.8052C4.25908 1.11879 4.58349 1.36746 4.7672 1.77824L7.40492 7.73465C7.45898 7.85358 7.49148 7.96164 7.49148 8.06979C7.49148 8.51299 7.14553 8.86972 6.70228 8.86972C6.31314 8.86972 6.05365 8.64273 5.90236 8.29673L5.39433 7.1077H2.06478L1.53508 8.35087C1.39451 8.67514 1.11352 8.86972 0.767561 8.86972C0.334997 8.86972 0 8.52381 0 8.09138C0 7.97246 0.0431859 7.85358 0.0972388 7.73465ZM4.77811 5.6375L3.72946 3.14034L2.68091 5.6375H4.77811Z",
    fill: "var(--fill-0, #1E1341)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.28017 7.14007V7.11843C8.28017 5.85367 9.2423 5.2699 10.6152 5.2699C11.199 5.2699 11.6206 5.36719 12.0314 5.50775V5.41047C12.0314 4.72937 11.6098 4.3511 10.7882 4.3511C10.3342 4.3511 9.96663 4.41592 9.65313 4.51326C9.55589 4.54567 9.49097 4.55644 9.41519 4.55644C9.03696 4.55644 8.73428 4.26458 8.73428 3.88626C8.73428 3.59436 8.91798 3.34573 9.17738 3.2484C9.69627 3.05383 10.2585 2.94572 11.026 2.94572C11.9232 2.94572 12.5718 3.18352 12.9827 3.59431C13.4151 4.02669 13.6096 4.66455 13.6096 5.44288V8.08051C13.6096 8.52381 13.2529 8.86967 12.8097 8.86967C12.334 8.86967 12.0205 8.53458 12.0205 8.18862V8.1778C11.6206 8.621 11.0691 8.91285 10.2693 8.91285C9.17738 8.91295 8.28017 8.28605 8.28017 7.14007ZM12.0529 6.7617V6.46984C11.7719 6.34014 11.4043 6.25363 11.0044 6.25363C10.3016 6.25363 9.8693 6.53471 9.8693 7.05356V7.0752C9.8693 7.51844 10.2368 7.77784 10.7665 7.77784C11.534 7.77788 12.0529 7.35633 12.0529 6.7617Z",
    fill: "var(--fill-0, #1E1341)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionFormatting);
export default __webpack_public_path__ + "static/media/OptionFormatting.7430e1781cfc9682d3cadedc3582a2c1.svg";
export { ForwardRef as ReactComponent };